
export default {
  head: {
    title: "银川建设采购服务平台",
    meta: {
      description: "银川建设采购服务平台",
      keywords: "银川建设采购服务平台",
    },
    icon: "/config/favicon.ico",
  },
  plugins: {
    element: true,
    myComs: true,
    vuexStorage: false,
    jquery: true,
    sentry: false,
    cnzz: {
      id: "1275340054",
      show: "pic1",
    },
  },
  proxy: {
    "/web": {
      target: "http://web.ycjs.com.cn/",
      changeOrigin: true,
    },
    "/venuereservationapi": {
      target: "http://web.ycjs.com.cn/",
      changeOrigin: true,
    },
    "/standalonfile": {
      target: "http://web.ycjs.com.cn/",
      changeOrigin: true,
    },
    "/ueditor":{
        target: "http://web.ycjs.com.cn/",
        changeOrigin: true,
    }
  },
};
